const readStatusCode = (error: unknown): number | undefined => {
    if (typeof error !== 'object' || !error || !('statusCode' in error)) return undefined;

    const status = (error as { statusCode?: number }).statusCode;

    return typeof status === 'number' ? status : undefined;
};

export const extractStatusCode = (error: unknown) => {
    const status = readStatusCode(error);

    if (typeof status === 'number') return status;

    if (typeof error === 'object' && error && 'cause' in error)
        return readStatusCode((error as { cause?: unknown }).cause);

    return undefined;
};
